import React from 'react';
import { Search, Users } from 'lucide-react';

interface PermissionsSearchProps {
  searchTerm: string;
  moduleCount: number;
  onSearchChange: (term: string) => void;
}

const PermissionsSearch: React.FC<PermissionsSearchProps> = ({
  searchTerm,
  moduleCount,
  onSearchChange
}) => {
  return (
    <div className="permissions-search-section">
      <div className="search-controls">
        <div className="search-input-container">
          <Search size={16} className="search-icon" />
          <input
            type="text"
            placeholder="Search modules..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="search-input"
          />
        </div>
      </div>
      
      <div className="module-count-info">
        <Users size={16} className="count-icon" />
        <span className="count-text">{moduleCount} modules configured</span>
      </div>
    </div>
  );
};

export default PermissionsSearch;